// /**
//  =========================================================
//  * Material Dashboard 2 React - v2.2.0
//  =========================================================

//  * Product Page: https://www.creative-tim.com/product/material-dashboard-react
//  * Copyright 2023 Creative Tim (https://www.creative-tim.com)

//  Coded by www.creative-tim.com

//  =========================================================

//  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
//  */

// import * as React from 'react';

// // @mui material components
// import Grid from "@mui/material/Grid";

// import MDInput from "../../../components/MDInput";
// import PropTypes from "prop-types";
// import {isEmpty} from "../../../components/Utils/common";
// import { useFormContext } from "react-hook-form";


// function MerchantOtherDetails({merchant, editmode, setMerchant}) {
//   const { register, formState: { errors } } = useFormContext();
//   return (
//       <Grid mt={3} mb={3} padding={2} bgColor="white">
//         <Grid container spacing={2} justifyContent="center">
//           <Grid item xs={3}>
//             <MDInput type="text" label="Max Transaction Amount" name="amountPerTrans"
//                      error={errors?.amountPerTrans}
//                      helperText={errors.amountPerTrans ? errors.amountPerTrans.message : ''}
//                      {...register("amountPerTrans")}
//                      fullWidth  disabled={!editmode} />
//           </Grid>
//           <Grid item xs={3}>
//             <MDInput type="text" label="Max Total Value per Day" name="allowedTotAmtPerDay"
//                      error={errors?.allowedTotAmtPerDay}
//                      helperText={errors.allowedTotAmtPerDay ? errors.allowedTotAmtPerDay.message : ''}
//                      {...register("allowedTotAmtPerDay")}
//                      fullWidth  disabled={!editmode} />
//           </Grid>
//           <Grid item xs={3}>
//             <MDInput type="text" label="Max No. Transactions per Day" name="allowedTransPerDay"
//                      error={errors?.allowedTransPerDay}
//                      helperText={errors.allowedTransPerDay ? errors.allowedTransPerDay.message : ''}
//                      {...register("allowedTransPerDay")}
//                      fullWidth  disabled={!editmode} />
//           </Grid>
//         </Grid>
//       </Grid>
//   );
// }

// MerchantOtherDetails.defaultProps = {
//   merchant: false,
//   editmode: false,
//   setMerchant: false
// }

// MerchantOtherDetails.propTypes = {
//   merchant: PropTypes.any,
//   editmode: PropTypes.bool,
//   setMerchant: PropTypes.func
// }

// export default MerchantOtherDetails;

// This tab is currently unused – no request fields are mapped here.
import * as React from 'react';
import PropTypes from "prop-types";

function MerchantOtherDetails({ merchant, editmode, setMerchant }) {
  return null;
}

MerchantOtherDetails.defaultProps = { merchant: false, editmode: false, setMerchant: false };
MerchantOtherDetails.propTypes = { merchant: PropTypes.any, editmode: PropTypes.bool, setMerchant: PropTypes.func };

export default MerchantOtherDetails;

